<template>
  <div class="h-navbar-wrapper">
    <!-- 已打开标签 -->
    <tabs-view></tabs-view>
  </div>
</template>
<script>
import TabsView from './TabsView'
export default {
  components: {
    TabsView
  }
}
</script>
